<template>
  <component
    :is="tag"
    :class="`favorite-js ${isFavorited ? 'favorite-active' : ''}`"
    @click.prevent="onClick"
  >
    <IconFavorite
      v-if="showIcon"
      :class="`${iconClass} ${isFavorited ? 'fill' : ''}`"
    />
    <slot />
  </component>
</template>

<script>
import IconFavorite from '../../../../templates/icons/favorite.svg';

export default {
  components: {
    IconFavorite,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    productId: {
      type: String,
      default: '',
      required: true,
    },
    storeName: {
      type: String,
      default: '',
    },
    productTitle: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFavorited: false,
    };
  },
  created() {
    this.isFavorited = window.favorite.isFavorited(this.productId);

    window.favorite.addEventListener('update', e => {
      this.isFavorited = e.detail.includes(this.productId);
    });
  },
  methods: {
    onClick() {
      window.favorite.toggleFavorite(
        null,
        this.productId,
        this.storeName,
        this.productTitle
      );
    },
  },
};
</script>
